import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { CMMessageColourDefaults } from '@/components/chat/_domain';

@Component({
  name: 'CMMessageColourComponent'
})

export default class CMMessageColourComponent extends TombolaBaseComponent {
  @Prop() private userPreferences: UserPreferences;
  private readonly DEFAULT_COLOUR = CMMessageColourDefaults.RED;
  private colourSelection: string[] = [];
  private cmMessageColour: string = null;


  private get selectedColour(): string {
    if (!this.cmMessageColour) {
      this.selectedColour = this.DEFAULT_COLOUR;
    }
    return this.cmMessageColour;
  }

  private set selectedColour(value: string) {
    this.cmMessageColour = value;
  }

  protected async created() {
    this.colourSelection = [
      CMMessageColourDefaults.RED,
      CMMessageColourDefaults.BLUE
    ];
    this.selectedColour = this.userPreferences.cmMessageColour;
  }

  public saveSettings() {
    this.userPreferences.cmMessageColour = this.selectedColour;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/user-settings/_components/cm-message-colour/cm-message-colour.component.ts